import { render, staticRenderFns } from "./header-searchbar.html?vue&type=template&id=5dfed807&scoped=true&"
import script from "./header-searchbar.js?vue&type=script&lang=js&"
export * from "./header-searchbar.js?vue&type=script&lang=js&"
import style0 from "./header-searchbar.scss?vue&type=style&index=0&id=5dfed807&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfed807",
  null
  
)

export default component.exports